import React, { useMemo, useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import Header from "../../components/Header/Header";
import BottomNav from "../../components/BottomNav/BottomNav";
import "./Affiliate.css";

export default function Affiliate({ onSubmit }) {
  const [formData, setFormData] = useState({
    part1: "A",
    part2: "A",
    part3: "A",
    password: "•••••••",
    confirmPassword: "",
    type: "",
    currency: "",
    domainType: "no-domain",
    email: "",
    phone: "",
    code: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const captchaCode = "19345";

  const affiliateSlug = useMemo(() => {
    const code = `${formData.part1}${formData.part2}${formData.part3}`.trim();
    return code || "AAA";
  }, [formData.part1, formData.part2, formData.part3]);

  const affiliateLink = ``;

  const handleChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      ...formData,
      affiliateCode: affiliateSlug,
      affiliateLink,
    };

    onSubmit?.(payload);
    console.log("affiliate form:", payload);
  };

  return (
    <div className="affiliate-page">
      <Header />

      <div className="affiliate-shell">
        <h1 className="affiliate-title">Affiliate Member</h1>

        <form className="affiliate-form" onSubmit={handleSubmit}>
          <div className="affiliate-field">
            <label className="affiliate-label">Affiliate Account Name</label>

            <div className="affiliate-name-row">
              <input
                type="text"
                className="affiliate-mini-input"
                value={formData.part1}
                onChange={(e) => handleChange("part1", e.target.value)}
              />
              <input
                type="text"
                className="affiliate-mini-input"
                value={formData.part2}
                onChange={(e) => handleChange("part2", e.target.value)}
              />
              <input
                type="text"
                className="affiliate-mini-input"
                value={formData.part3}
                onChange={(e) => handleChange("part3", e.target.value)}
              />
            </div>
          </div>

          <div className="affiliate-field">
            <label className="affiliate-label">Password</label>

            <div className="affiliate-input-wrap">
              <input
                type={showPassword ? "text" : "password"}
                className="affiliate-input"
                value={formData.password}
                onChange={(e) => handleChange("password", e.target.value)}
              />
              <button
                type="button"
                className="affiliate-eye-btn"
                onClick={() => setShowPassword((prev) => !prev)}
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? <EyeOff size={24} /> : <Eye size={24} />}
              </button>
            </div>
          </div>

          <div className="affiliate-field">
            <label className="affiliate-label">Confirm Password</label>

            <div className="affiliate-input-wrap">
              <input
                type={showConfirmPassword ? "text" : "password"}
                className="affiliate-input"
                value={formData.confirmPassword}
                onChange={(e) => handleChange("confirmPassword", e.target.value)}
              />
              <button
                type="button"
                className="affiliate-eye-btn"
                onClick={() => setShowConfirmPassword((prev) => !prev)}
                aria-label={
                  showConfirmPassword
                    ? "Hide confirm password"
                    : "Show confirm password"
                }
              >
                {showConfirmPassword ? <EyeOff size={24} /> : <Eye size={24} />}
              </button>
            </div>
          </div>

          <div className="affiliate-field">
            <label className="affiliate-label">Type</label>
            <select
              className={`affiliate-select ${formData.type ? "has-value" : ""}`}
              value={formData.type}
              onChange={(e) => handleChange("type", e.target.value)}
            >
              <option value="">Please select</option>
              <option value="agent">Agent</option>
              <option value="sub-agent">Sub Agent</option>
              <option value="affiliate">Affiliate</option>
            </select>
          </div>

          <div className="affiliate-field">
            <label className="affiliate-label">Currency</label>
            <select
              className={`affiliate-select ${formData.currency ? "has-value" : ""}`}
              value={formData.currency}
              onChange={(e) => handleChange("currency", e.target.value)}
            >
              <option value="">Please select</option>
              <option value="BDT">BDT</option>
              <option value="INR">INR</option>
              <option value="USD">USD</option>
            </select>
          </div>

          <div className="affiliate-field">
            <div className="affiliate-radio-row">
              <label className="affiliate-radio-item">
                <input
                  type="radio"
                  name="domainType"
                  checked={formData.domainType === "no-domain"}
                  onChange={() => handleChange("domainType", "no-domain")}
                />
                <span className="affiliate-radio-text">No Domain</span>
              </label>

              <label className="affiliate-radio-item">
                <input
                  type="radio"
                  name="domainType"
                  checked={formData.domainType === "domain"}
                  onChange={() => handleChange("domainType", "domain")}
                />
                <span className="affiliate-radio-text">Domain</span>
              </label>
            </div>

            <div className="affiliate-link-preview">{affiliateLink}</div>
          </div>

          <div className="affiliate-field">
            <label className="affiliate-label">Email</label>
            <input
              type="text"
              className="affiliate-input"
              value={formData.email}
              onChange={(e) => handleChange("email", e.target.value)}
            />
          </div>

          <div className="affiliate-field">
            <label className="affiliate-label">Phone Number</label>
            <input
              type="tel"
              className="affiliate-input"
              value={formData.phone}
              onChange={(e) => handleChange("phone", e.target.value)}
            />
          </div>

          <div className="affiliate-field">
            <label className="affiliate-label">Code</label>

            <div className="affiliate-code-row">
              <input
                type="text"
                className="affiliate-code-input"
                value={formData.code}
                onChange={(e) => handleChange("code", e.target.value)}
              />
              <div className="affiliate-code-box">{captchaCode}</div>
            </div>
          </div>

          <button type="submit" className="affiliate-submit-btn">
            Submit
          </button>
        </form>
      </div>

      <BottomNav />
    </div>
  );
}